<template>
  <div
    class="card faq-card p-5 border-rounded"
    :data-cy="dataCyName([title, 'faq'])"
  >
    <div
      class="faq-card__header row align-items-center cursor-pointer"
      @click="(evt) => emit('toggleAnswer')"
    >
      <div class="col col-sm-1 col-2 text-center d-inline lh-lg">
        <strapi-image :force-width="25" :image="iconUrl" :alt="title" />
      </div>
      <div class="col col-sm-10 col-8">
        {{ title }}
      </div>
      <div class="col col-sm-1 col-2 text-center d-inline">
        <fa-icon
          v-if="isOpened"
          class="fs-tiny text-rhino"
          :icon="faMinus"
          aria-hidden="true"
        />
        <fa-icon
          v-else
          class="fs-tiny text-rhino"
          :icon="faPlus"
          aria-hidden="true"
        />
      </div>
    </div>
    <div class="faq-card__body py-5 mt-5" :class="{ collapse: !isOpened }">
      <common-md-content
        v-if="content"
        v-slot="{ renderedContent }"
        :content="content"
      >
        <!-- content is unlikely to be changed during runtime, so set v-once here -->
        <div v-once v-html="renderedContent"></div>
      </common-md-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiImage } from '~/apollo/types/types';
import dataCyName from '~/helpers/cypress';

defineOptions({
  name: 'StrapiFaqItem',
});

withDefaults(
  defineProps<{
    content: string;
    title: string;
    iconUrl: StrapiImage;
    isOpened?: boolean;
  }>(),
  {
    isOpened: false,
  },
);

const emit = defineEmits<{
  (e: 'toggleAnswer'): void;
}>();
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/colors';

.faq-card {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  background-color: $gp-dark-mouse;

  &__header {
    border: 0;
    background-color: $gp-dark-mouse;
    font-size: 1.25rem;
    font-weight: bold;
    line-height: 1;
    padding: 0;
  }

  &__body {
    border-top: 1px solid $gp-rhino;
  }
}
</style>
